/**
 * @license
 * Copyright (c) 2023 Entelechy Corporation. All rights reserved.
 */

import { LitElement, css } from "lit";

export class ECComponent extends LitElement {

  static styles = [
    css`
      div.main {
        text-align: left;
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        text-align: center;
        padding: 12px;
      }
      div#content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-family: sans-serif;
      }
      button {
        font-size: max(min(2vw, 2vh), 20px);
        font-weight: bold;
        cursor: pointer;
        background-color: var(--button-bgcolor);
        color: var(--button-fgcolor);
        border-radius: var(--button-border-radius);
        -moz-border-radius: var(--button-border-radius);
        -webkit-border-radius: var(--button-border-radius);
        cursor: pointer;
        padding: 0.75vh 4vw;
        width: fit-content;
      }
      button:disabled {
        background-color: var(--button-bgcolor-disabled);
        color: var(--button-fgcolor-disabled);
      }
      button:hover {
        filter: brightness(110%);
      }
    `
  ]
}
